export default __webpack_public_path__ + "static/media/WhatsAppButtonGreenLarge.0a373e34.svg";